<template>
  <ValidationForm id="edit-event-form" :onSubmit="submit" :onReset="reset">
    <div class="form-row">
      <div class="form-group col-12">
        <label for="txtGeneralName">Name</label>
        <input type="text" class="form-control" id="txtGeneralName" placeholder="Name of the event"
          v-model="event.name" />
      </div>
      <div class="form-group col-12" v-if="event.event_type_id === 3">
        <label for="txtDescription">Description</label>
        <input type="text" class="form-control" id="txtDescription" placeholder="A friendly description of the event"
          v-model="event.description" />
      </div>
    </div>
    <div class="form-row" v-if="event.event_type_id === 3">
      <div class="form-group col-md-12">
        <label for="ddlDevice">Device</label>
        <select id="ddlDevice" class="form-control" v-model="event.device_id">
          <option value="null">None</option>
          <option v-for="device in filtered_devices" :key="device.device_id" v-bind:value="device.device_id">
            {{ device.name }}
          </option>
        </select>
        <small class="form-text text-muted">Only relevant if you have a Barionet device.</small>
      </div>
      <div class="form-group col-md-12" v-if="event.device_id !== null">
        <label for="txtInputNumber">Input</label>
        <input type="text" class="form-control" id="txtInputNumber" v-model="event.input_number" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12" v-if="event.event_type_id === 3">
        <label for="ddlAlertActionType">Action Type</label>
        <select class="form-control" id="ddlAlertActionType" v-model="event.event_action_type_id">
          <option value="0">Select..</option>
          <option v-for="event_action_type in event_action_types" :key="event_action_type.event_action_type_id"
            v-bind:value="event_action_type.event_action_type_id">
            {{ event_action_type.name }}
          </option>
        </select>
      </div>
    </div>
    <ValidationField id="txtExtension" label="Extension"
      helperText="Not required, but can only play from web interface if left at 9. If inputted, must keep leading 9 and follow with 3 numbers. Example: 9001"
      v-model="event.extension" :validator="validate" />

    <div class="form-check" v-if="event.event_type_id === 3">
      <input id="chkChat" type="checkbox" class="form-check-input" v-model="event.chat_enabled" @click="handleChatChange" />
      <label for="chkChat" class="form-check-label">Enable aChat</label>
      <small class="form-text text-muted" v-if="!feature_g2_secure_enabled">G2 Secure is not enabled for this account</small>
    </div>
  </ValidationForm>
</template>

<script>
import { mapGetters } from 'vuex'
import ValidationMixin from '../../mixins/ValidationMixin.vue'
import { AlertExtensionValidator } from '../../assets/js/validators'
import { DEVICE_TYPE, EVENT_TYPE } from '../../assets/js/resource-types'

export default {
  props: { event: Object },
  mixins: [ValidationMixin],
  computed: {
    ...mapGetters({
      devices: 'allDevices',
      event_action_types: 'allEventActionTypes',
      scoped_site_id: 'scopedSiteId',
      feature_g2_secure_enabled: 'featureG2SecureEnabled'
    }),
    filtered_devices: function () {
      return this.devices.filter(device =>
        device.device_type_id === DEVICE_TYPE.Barionet && device.site_id === this.scoped_site_id
      )
    }
  },
  methods: {
    validate(value) {
      const validator = new AlertExtensionValidator(this.extensions_in_use, this.initial_event_extension)
      return validator.validate(value)
    },
    handleChatChange(e) {
      if (!this.feature_g2_secure_enabled && e.target.checked) {
        alert('G2 Secure is not enabled for your account. You must have G2 Secure enabled to use aChat for an alert. For more information, please visit our website at https://www.galaxynext.us/, or contact us at sales@galaxynext.us to get started.')
        e.target.checked = false
      }
    },
    submit() {
      this.$store.dispatch('addEditEvent', { event: this.event })
    },
    reset() {
      this.$store.dispatch('getEvent', this.event.event_id)
    }
  },
  created() {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getDevices')
    this.$store.dispatch('getEventActionTypes')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
  },
  updated() {
    if (!this.initial_event_extension && this.event) this.initial_event_extension = this.event.extension

    if(this.event.chat_enabled && !this.feature_g2_secure_enabled) {
      this.event.chat_enabled = 0
    }
  }
}
</script>